export default __webpack_public_path__ + "static/media/contact-paper-final.64a028f2.webp";